var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeAvatar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0456,
    cy: 35.0454,
    r: 33.3766,
    fill: "#DFEBEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1075 22.7374H46.5178V20.4431C46.5189 16.6408 43.4362 13.5592 39.635 13.5592H30.4568C26.6545 13.5592 23.5728 16.6408 23.5728 20.4431V22.7374H18.9832C16.4512 22.7449 14.4011 24.7961 14.3936 27.3271V50.2731C14.4011 52.804 16.4512 54.8552 18.9832 54.8628H51.1086C53.6395 54.8552 55.6907 52.8051 55.6982 50.2731V27.3271C55.6907 24.7961 53.6405 22.7449 51.1086 22.7374H51.1075ZM28.1614 20.4431C28.1614 19.1761 29.1886 18.1488 30.4557 18.1488H39.6339C40.901 18.1488 41.9282 19.1761 41.9282 20.4431V22.7374H28.1603V20.4431H28.1614Z",
    fill: "#307F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9598 35.7107C31.7683 35.7107 31.6231 35.7107 31.4779 35.7107C30.3894 35.7107 28.762 35.7075 27.6735 35.7118C26.8065 35.715 26.3247 36.1936 26.3225 37.0595C26.3225 37.693 26.3225 39.8948 26.3225 40.5413C26.3257 41.4147 26.7969 41.8826 27.6703 41.8858C28.7728 41.8901 30.4131 41.8858 31.5156 41.8858C31.6565 41.8858 31.7985 41.8858 31.9609 41.8858C31.9609 43.184 31.9587 44.9577 31.9609 46.1936C31.963 47.038 32.4341 47.5188 33.2839 47.5241C34.0379 47.5241 36.1827 47.5241 36.8054 47.5241C37.6649 47.5198 38.1338 47.0294 38.1371 46.1538C38.1403 45.0653 38.1371 43.4379 38.1371 42.3494C38.1371 42.2063 38.1371 42.0633 38.1371 41.8858C38.3339 41.8858 38.478 41.8858 38.6232 41.8858C39.7257 41.8858 41.366 41.8901 42.4686 41.8836C43.2806 41.8793 43.769 41.3867 43.769 40.5703C43.769 39.8787 43.769 37.7221 43.769 37.0487C43.7668 36.2119 43.2785 35.7161 42.4449 35.7107C41.3424 35.7042 39.7021 35.7085 38.5996 35.7085C38.4565 35.7085 38.3145 35.7085 38.1371 35.7085C38.1371 35.5128 38.1371 35.3676 38.1371 35.2224C38.1371 34.1338 38.1414 32.5064 38.136 31.4179C38.1317 30.5606 37.6369 30.0745 36.7753 30.0745C36.2386 30.0745 33.8281 30.0745 33.3742 30.0745C32.4245 30.0745 31.9609 30.5348 31.9598 31.4771C31.9587 32.6861 31.9598 34.4318 31.9598 35.7085V35.7107Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.3036,
    height: 41.3036,
    fill: "white",
    transform: "translate(14.3936 13.5592)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar3);
export default __webpack_public_path__ + "static/media/Office-Avatar-3.e38ecc7e64f2327a17dca8a7434e5922.svg";
export { ForwardRef as ReactComponent };